import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="contacts--persons-validate"
//
// Closes the Validate tab's task drawer after a successful submit. The drawer is
// rendered once outside the panel region so its state survives a panel re-render,
// which is why the close has to be driven from here rather than from the form.
export default class extends Controller {
  taskCreated(event) {
    if (!event.detail?.success) return

    const el = document.getElementById("contact-task-drawer")
    if (!el) return

    const controller = this.application.getControllerForElementAndIdentifier(
      el,
      "ui--drawer",
    )
    controller?.close()
    el.querySelector("form")?.reset()
  }
}
